import type { TaskCardFields } from './taskDashboardSettings'

export interface TaskDashboardColumn {
  id: string
  name: string
  groupable: boolean
  sortable: boolean
}

/** Headers of the list view, in the mockup order. */
export const LIST_COLUMNS = [
  'task_name',
  'deceased',
  'funeral_date',
  'item',
  'category_id',
  'funeral_home_id',
  'company_id',
  'responsable',
  'assigned_person',
  'created_at',
  'due_date_type',
  'due_date',
  'status'
]

/**
 * List columns driven by the "displayed information" options, like the card lines.
 * Columns absent from this map (task, deceased, category, status) are always shown.
 */
const LIST_COLUMN_FIELDS: Record<string, keyof TaskCardFields> = {
  funeral_date: 'funeral_date',
  item: 'item',
  funeral_home_id: 'funeral_home',
  company_id: 'company',
  responsable: 'responsable',
  assigned_person: 'assigned',
  created_at: 'created_at',
  due_date_type: 'due_date',
  due_date: 'due_date'
}

export const visibleListColumns = (fields: TaskCardFields): string[] =>
  LIST_COLUMNS.filter((column) => {
    const field = LIST_COLUMN_FIELDS[column]
    return field === undefined || fields[field]
  })

export const groupableColumns = (
  columns: TaskDashboardColumn[]
): TaskDashboardColumn[] => columns.filter((column) => column.groupable)

export const sortableColumns = (
  columns: TaskDashboardColumn[]
): TaskDashboardColumn[] => columns.filter((column) => column.sortable)

/** Display name of a column, falling back on its id when the column is unknown. */
export const columnLabel = (
  columns: TaskDashboardColumn[],
  columnId: string | null
): string =>
  columnId === null
    ? ''
    : (columns.find((column) => column.id === columnId)?.name ?? columnId)
